/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';

import TableItem from '../table-item';
import { Typography } from '../typography';
import Styled from './styles';

interface HookState {
	rows: any[];
}

const Table: FC<any> = props => {
	const { data, fieldsToDisplay, fieldsConfig, defaultFields} = props;
	const listInnerRef = useRef<any>(null);

	const [state, setState] = useState<HookState>({
		rows: [],
	});

	const { rows } = state;

	useEffect(() => {
		sliceData(true);
	}, [data]);

	const onScroll = () => {
		if (listInnerRef.current) {
			const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
			if (scrollTop + clientHeight !== scrollHeight) return;
			if (rows.length === data.length) return;
			sliceData(false);
		}
	};

	const setTitle = (type: string): string => {
		const regex = /\d+/;
		let result = type.replace(/([A-Z])/g, ' $1');
		const number = result.match(regex);
		result = number ? result.replace(number[0], ` ${number[0]}`) : result;
		return result.charAt(0) + result.slice(1);
	};

	const sliceData = (fromStart: boolean) => {
		const slicedData = fromStart ? [...data].splice(0, 10) : [...data].splice(rows.length, 10);
		setState(prev => ({
			...prev,
			rows: fromStart ? [...slicedData] : [...prev.rows, ...slicedData],
			isExpand: false,
		}));
	};

	const titles = useMemo(() => {
		if (!rows.length) {
			return [];
		}
		const currentFields = fieldsToDisplay?.length
			? [...defaultFields, ...fieldsToDisplay]
			: [...fieldsToDisplay, ...Object.keys(rows[0])];
		return currentFields
			.filter((el: string) => el !== '_id')
			.map((title: string) => ({
				original: title,
				display: setTitle(title).trim().toLocaleUpperCase(),
			}));
	}, [rows]);

	if (!rows.length) return null;

	return (
		<Styled.Content>
			<Styled.Wrapper ref={listInnerRef} onScroll={onScroll}>
				<table>
					<thead>
						<tr style={{ height: 50 }}>
							{titles.map((item: any, i: number) => (
								<th
									key={i}
									style={{ minWidth: 180, backgroundColor: '#EFF2F5' }}
								>
									<Typography
										text={item.display}
										size="large"
										color="btnTextGrey"
									/>
								</th>
							))}
						</tr>
					</thead>

					<tbody style={{ overflow: 'hidden' }}>
						{rows.map((item: any, i: number) => (
							<Styled.Row key={i}>
								<TableItem
									{...props}
									item={item}
									titles={titles}
									highlight={fieldsConfig?.highlight}
								/>
							</Styled.Row>
						))}
					</tbody>
				</table>
			</Styled.Wrapper>
		</Styled.Content>
	);
};

export default React.memo(Table);
